/**
 * MADERINCO-LISTA-ITEMS-SECCIONES-T1 (Ares #36434) -- reglas del boton "Cargar capitulos aprobados" (sin DOM).
 *
 * Mismo camino que el catalogo (cargaCatalogo.js, #29190). Contrato: POST /api/v1/presupuestos/plantilla/capitulos/cargar
 * de nexo-api 640 (leido en 511c696). Gerente o admin; solo el negocio demo. El cuerpo es el JSON TAL CUAL: la API calcula
 * el sha256 del texto recibido y solo entra el aprobado por Q (419e53d0..., 29872 B). Por eso el panel manda el File y
 * nunca lo lee ni lo reformatea. 200 = {listaSha, capitulos, lineas}; repetir no duplica. Errores (ProblemDetails):
 * 409 CAPITULOS_NO_APROBADOS, 422 FUENTE_NO_EXISTE (con la lista de fuenteId), 400 CAPITULOS_INVALIDOS, 403.
 * Lo prueba scripts/check-carga-capitulos.mjs.
 *
 * @module application/presupuestos/cargaCapitulos
 */

/** El archivo aprobado pesa 29872 B; el tope solo evita mandar algo que claramente no es la lista. */
export const MAX_BYTES_CAPITULOS = 1024 * 1024;

/** null = se puede mandar; si no, la frase de por que no. No lee el contenido. */
export function revisarArchivoCapitulos(file) {
  if (!file) return 'Elige el archivo de las secciones aprobadas.';
  if (!/\.json$/i.test(file.name || '')) return 'Las secciones van en un archivo .json.';
  if (!(file.size > 0)) return 'Ese archivo está vacío.';
  if (file.size > MAX_BYTES_CAPITULOS) return 'Ese archivo pesa demasiado para ser la lista de secciones.';
  return null;
}

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

/** La respuesta de la API en una forma (tolera camelCase y PascalCase). */
export function resumenDeCargaCapitulos(data) {
  const d = data?.data ?? data ?? {};
  const sha = String(d.listaSha ?? d.ListaSha ?? '');
  return { capitulos: num(d.capitulos ?? d.Capitulos), lineas: num(d.lineas ?? d.Lineas), sha, sha16: sha.slice(0, 16) };
}

export function fraseDeCargaCapitulos(r) {
  return `Secciones cargadas: ${r.capitulos} secciones y ${r.lineas} líneas. Repetirlo no duplica nada.`;
}

/**
 * Josse #36553 (obs de Q #36606): al usuario nunca se le dice "capitulo". La API explica el rechazo con su nombre interno
 * ("capitulo 3: repetido", "linea 4: el capitulo 9 no esta en la lista de capitulos"); antes de pintarlo se dice seccion.
 */
export function enSecciones(texto) {
  const S = (c, resto) => (c === 'C' ? 'S' : 's') + resto;
  return String(texto ?? '')
    .replace(/\b([Dd])el (c)ap[ií]tulo\b/g, (m, d, c) => `${d}e la ${S(c, 'ección')}`)
    .replace(/\b([Ee])l (c)ap[ií]tulo\b/g, (m, e, c) => `${e === 'E' ? 'L' : 'l'}a ${S(c, 'ección')}`)
    .replace(/\b([Cc])ap[ií]tulos\b/g, (m, c) => S(c, 'ecciones'))
    .replace(/\b([Cc])ap[ií]tulo\b/g, (m, c) => S(c, 'ección'))
    // Pegada a otra palabra (CapitulosSha, Q #36629): sin limite de palabra, tambien se cambia.
    .replace(/([Cc])ap[ií]tulo(s?)/g, (m, c, pl) => S(c, pl ? 'ecciones' : 'ección'));
}

/** La causa, por codigo de la API (el ProblemDetails) o del cliente. */
export function fraseDelErrorCapitulos(error) {
  const code = String(error?.code || '');
  const detalle = error?.detalle ? ` (${enSecciones(error.detalle)})` : '';
  switch (code) {
    // Q #36629: su detalle trae la huella y una clave de configuracion (Presupuestos:CapitulosSha); no es para el usuario.
    case 'CAPITULOS_NO_APROBADOS': return 'Esa no es la lista aprobada: no se cargó nada. Elige el archivo de secciones que se aprobó.';
    case 'CAPITULOS_INVALIDOS': return `La lista tiene problemas: no se cargó nada${detalle}.`;
    case 'FUENTE_NO_EXISTE': return `La lista pide ítems que no están en la plantilla: no se cargó nada${detalle}. Carga primero el catálogo aprobado.`;
    case 'PUERTA_CERRADA': return 'La carga solo está abierta en el negocio demo. Cambia el negocio con el selector de arriba.';
    case 'SIN_SESION': return 'Tu sesión venció: vuelve a entrar y repite la carga.';
    case 'FORBIDDEN': return 'Solo un gerente o un administrador del negocio puede cargar las secciones.';
    case 'NOT_IMPLEMENTED': return 'La carga de secciones todavía no está publicada en la API.';
    case 'NETWORK': return 'No pudimos hablar con la API ahora. Intenta en un momento.';
    default: return `No pudimos cargar las secciones (${code || 'error'})${detalle}.`;
  }
}
